/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import React, { Component } from 'react';
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core/styles';
import Auth from '../Auth/Auth';

const theme = createMuiTheme({
    palette: {
        primary: {
            // light: will be calculated from palette.primary.main,
            main: '#000',
            dark: "#3182c1",
            // dark: will be calculated from palette.primary.main,
            // contrastText: will be calculated to contrast with palette.primary.main
        },
        text: {
            // Use the system font instead of the default Roboto font.
            primary: '#3182c1',
        },
        // error: will use the default color
    },
    typography: {
        // Use the system font instead of the default Roboto font.
        fontFamily: 'Wfvisualsans, Helvetica Neue, Helvetica, Arial, sans-serif',
    },

});

const shadow = (w) => css`
    z-index: 2;
    .con{
        max-width: ${w}px;
        display: flex;
        flex-direction: column;
        width: 100%;
        height: 100%;
        align-items: center;
        margin: auto;
    }
    `;

const container = () => css`
background-color: #fdfdfd;
    p, button, button span,label{
        font-family: Manrope, sans-serif !important;
        letter-spacing: -0.01em;
    }
    font-family:Manrope, sans-serif !important;
    letter-spacing: -0.01em;
    input::placeholder {
        color: #666666 !important;
        opacity: 1;
        font-family: Manrope, sans-serif !important;
    }
        #password{
            padding-left: 16px;
        }
    `;
const logo = () => css`
    font-family: gilmer;
    font-weight: 500;
    font-size: 26px;
    letter-spacing: -.5px;
    align-items: center;
    line-height: 5px;
    `;

const backgroundImg = () => css`
    position: relative;
    overflow: hidden;
    background-color: #000;
    display:flex;
    flex:1;
    border-radius: 10px;
    align-items: end;
        padding: 40px;
    padding-bottom: 5%;
    max-height: 1100px;
    max-width: 800px;
    @media (max-width: 1540px) {
        max-height: 800px;
        max-width: 650px;
    }
    .bg-video {
        position: absolute;
        inset: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
        z-index: 0;
        pointer-events: none;
    }
    .noise {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        pointer-events: none;
        background-repeat: repeat;
        background-size: var(--noise-size, 80px);
        mix-blend-mode: overlay;
        opacity: var(--noise-opacity, 0.6);
        z-index: 1;
    }
    &::after {
        content: '';
        position: absolute;
        width: 100%;
        height: 100%;
        inset: 0;
        background-color: rgba(0, 0, 0, .75);
        opacity: .8;
        z-index: 1;
        pointer-events: none;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        color: #fff;
    }
    .f-block {
        position: relative;
        z-index: 2;
    }
    .header-icon {
    border-radius: 10px;
    justify-content: center;
    align-items: center;
    margin-right: 10px;
    display: flex;
    width: 36px;
    height: 36px;
    img{
        width:100%;
    }
}
h3{
    color: #fff;
    font-size: 42px;
    line-height: 46px;
    font-weight: 700;
    padding-top: 0;
    margin-top: 5px;
}
p{
    color: #fff;
        font-size: 18px;
}
    .top-fade {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        height: 220px;
        z-index: 2;
        pointer-events: none;
        background: linear-gradient(to bottom, rgba(0,0,0,0.85) 0%, rgba(0,0,0,0.6) 40%, rgba(0,0,0,0) 100%);
    }
    .feature-scroll {
        position: absolute;
        top: 40px;
        left: 40px;
        height: 350px;
        overflow: hidden;
        z-index: 3;
        pointer-events: none;
        -webkit-mask-image: linear-gradient(to bottom, #000 0%, #000 70%, transparent 100%);
                mask-image: linear-gradient(to bottom, #000 0%, #000 70%, transparent 100%);
    }
    .feature-scroll ul {
        list-style: none;
        margin: 0;
        padding: 0;
        animation: featureScroll var(--fs-total) infinite;
        animation-timing-function: ease-in-out;
    }
    .feature-scroll li {
        height: var(--fs-row);
        line-height: var(--fs-row);
        font-size: 32px;
        font-weight: 700;
        color: rgba(255, 255, 255, 0.28);
        font-family: Manrope, sans-serif;
        letter-spacing: -0.01em;
        white-space: nowrap;
        animation: featureFlash var(--fs-total) infinite;
        animation-timing-function: ease-in-out;
    }
    `;

const FEATURES = [
    'Scheduling',
    'Team Management',
    'Time and Attendance',
    'Team Communication',
    'Time-off Controls & PTO Tracking',
    'Cost Management',
    'Reporting',
    'Remote Team Tools',
    'Departments & Roles',
    'Forms, Checklists & Surveys',
    'Audits',
    'Task Manager',
    'Quizzes/Lessons',
];

const FS_ROW = 40; // px per row
const FS_PER_ITEM = 1.6; // seconds each item stays at the top
const FS_HOLD_FRACTION = 0.82; // 82% hold, 18% slide

const buildFeatureKeyframes = () => {
    const n = FEATURES.length;
    let scroll = '@keyframes featureScroll {';
    for (let i = 0; i <= n; i++) {
        const startPct = (i / n) * 100;
        scroll += ` ${startPct.toFixed(4)}% { transform: translateY(${-i * FS_ROW}px); }`;
        if (i < n) {
            const holdPct = ((i + FS_HOLD_FRACTION) / n) * 100;
            scroll += ` ${holdPct.toFixed(4)}% { transform: translateY(${-i * FS_ROW}px); }`;
        }
    }
    scroll += ' }';
    const total = n * FS_PER_ITEM;
    const fade = 0.4; // seconds for color transition
    const fadePct = (fade / total) * 100;
    const holdEndPct = ((FS_HOLD_FRACTION) / n) * 100;
    const greyByPct = Math.min(holdEndPct + fadePct, 100);
    const fadeBackStartPct = Math.max(100 - fadePct, greyByPct);
    const flash = `@keyframes featureFlash {
        0% { color: #fff; }
        ${holdEndPct.toFixed(4)}% { color: #fff; }
        ${greyByPct.toFixed(4)}% { color: rgba(255,255,255,0.28); }
        ${fadeBackStartPct.toFixed(4)}% { color: rgba(255,255,255,0.28); }
        100% { color: #fff; }
    }`;
    return scroll + ' ' + flash;
};

const featureKeyframes = buildFeatureKeyframes();

class TwoSidedLayout extends Component {
    constructor(props) {
        super(props);
        this.auth = new Auth();
        this.state = {
        };
    }

    login = e => {
        e.preventDefault()

        this.auth.login();
    }

    render() {

        return (
            <MuiThemeProvider theme={theme}>
                <div className="main__container simple-layout auth-layout displayflex" css={container}>
                    <div className="flexcolumn left" style={{ flex: 2 }} css={shadow(this.props.width)}>
                        <div className="displayflex aligncenter width100 logo ">
                            <img src="https://teamsly-cdn-cuc0cvgwakbtarf9.z01.azurefd.net/images/teamsly-logo-35.png" className=" mr10" style={{ height: 24 }} />
                        </div>
                        <div className="displayflex aligncenter width100 logo displaynone">
                            <img src="https://teamsly-cdn-cuc0cvgwakbtarf9.z01.azurefd.net/images/logo-color-square.svg" className=" mr5" style={{ height: 24 }} />

                            <div className="ml5" css={logo }>teamsly</div>
                        </div>
                        <section className="app-builder__body custom-scrollbar height100 con">
                            <div className="app-style-page app-builder-page width100 flexcolumn layout">

                                <div className="login-page login-background">
                                    <div className="login-page__content">
                                        {this.props.children}
                                    </div>
                                </div>



                            </div>
                        </section>
                    </div>
                    <div className="flexcolumn justifycenter right prelative pt15 pr15 pb15" style={{ flex: 2, padding:'0 0px 0 80px', boxShadow:'inset 1px 0 0 0 rgba(0, 0, 0, .05)' }}>
                        <div css={ backgroundImg }>
                            <video
                                className="bg-video"
                                src="https://ertools.blob.core.windows.net/images/videos/login-signup-video.mp4"
                                poster="https://cdn.prod.website-files.com/66b58823c7015d385cecf0bd/69fe27ca8cb1117ed23d1c9c_frame-3.avif"
                                autoPlay
                                muted
                                loop
                                playsInline
                                preload="auto"
                            />
                            <div
                                className="noise"
                                style={{ '--noise-opacity': 0.5, '--noise-size': '80px', backgroundImage: "url('https://cdn.prod.website-files.com/66b58823c7015d385cecf0bd/69fea5d38c01de2944e2c89f_noise.svg')" }}
                            />
                           
                            <style>{featureKeyframes}</style>
                            <div className="top-fade" />
                            <div
                                className="feature-scroll"
                                style={{
                                    '--fs-row': `${FS_ROW}px`,
                                    '--fs-total': `${FEATURES.length * FS_PER_ITEM}s`,
                                }}
                            >
                                <ul>
                                    {[...FEATURES, ...FEATURES].map((f, idx) => (
                                        <li
                                            key={idx}
                                            style={{
                                                animationDelay: `${((idx % FEATURES.length) - FEATURES.length) * FS_PER_ITEM}s`,
                                            }}
                                        >
                                            {f}
                                        </li>
                                    ))}
                                </ul>
                            </div>
                            <div className="f-block">
                                <div class="header-icon">
                                    <img src="https://cdn.prod.website-files.com/66b58823c7015d385cecf0bd/69e64883d3a160827f8e1acb_blue-logo-login.avif" />
                                </div>
                                <h3>Cut time spent on creating schedules by 30%</h3>
                                <p>Schedules, time clock, timesheets, tasks, forms, audits, quizzes & lessons to manage your team.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </MuiThemeProvider>
        );
    }
}

export default TwoSidedLayout;